export const GROK_API_KEY = import.meta.env.VITE_GROK_API_KEY as string;
export const GROK_API_BASE = "https://api.groq.com/openai/v1";
export const GROK_STT_URL = `${GROK_API_BASE}/audio/transcriptions`;
export const GROK_TTS_URL = `${GROK_API_BASE}/audio/speech`;
